import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHero from 'tio-ui/components/page-hero';
import SectionHeader from 'tio-ui/components/section-header';
import FilterTabs from 'tio-ui/components/filter-tabs';
import type { FilterTab } from 'tio-ui/components/filter-tabs';
import { PhChatsCircle, PhChalkboardTeacher } from 'ember-phosphor-icons';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';

const ROUTE_PREFIX = 'authenticated.repaying-student-debt.coaching';

export default class CoachingPage extends Component {
  @service declare router: RouterService;
  @service declare intl: IntlService;

  get tabs(): FilterTab[] {
    return [
      {
        id: 'about',
        label: this.intl.t('coaching.about.tab_title'),
      },
      {
        id: 'schedule',
        label: this.intl.t('coaching.schedule_time.tab_title'),
      },
    ];
  }

  get activeTab(): string {
    const name = this.router.currentRouteName ?? '';
    if (name === `${ROUTE_PREFIX}.schedule`) return 'schedule';
    return 'about';
  }

  setTab = (id: string) => {
    const route = id === 'schedule' ? `${ROUTE_PREFIX}.schedule` : `${ROUTE_PREFIX}.index`;
    this.router.transitionTo(route);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  <template>
    <VStack class="gap-8 pb-12">
      <PageHero
        @icon={{PhChatsCircle}}
        @title={{t "coaching.about.how_can_we_help_q"}}
        @subtitle={{t "coaching.about.how_can_we_help_a"}}
        @gradient="brand"
        @decoration="circles"
        @rounded="2xl"
      />

      <div>
        <SectionHeader
          @level={{2}}
          @icon={{PhChalkboardTeacher}}
          @title={{t "coaching.student_loan_coaches"}}
          @iconClass="tio-fg-brand"
        />
        <FilterTabs
          @tabs={{this.tabs}}
          @activeId={{this.activeTab}}
          @onSelect={{this.setTab}}
          @activeClass="tio-filter-tab-active--indigo"
          @showCounts={{false}}
          class="mb-6"
        />
        {{outlet}}
      </div>
    </VStack>
  </template>
}
